export default {
  shootSpeed: 1,
  transitionTimer: 200
};

export const GAME_STATUS_LOSE = 'GAME_STATUS_LOSE';
export const GAME_STATUS_RUN = 'GAME_STATUS_RUN';
export const GAME_STATUS_WIN = 'GAME_STATUS_WIN';



// WEBPACK FOOTER //
// ./src/settings/game.js